import DateCell from '@blocks/DateCell'
import React from 'react'
import { Column } from "react-table"

export default [
    {
        Header: 'Name',
        accessor: 'name',
        width: "100%"
    },
    {
        Header: 'Type',
        accessor: 'type',
        Cell: ({ value }) => <span style={{ textTransform: "capitalize" }}>{value}</span>
    },
    {
        Header: 'Start date',
        accessor: 'start_date',
        Cell: DateCell
    },
    {
        Header: 'Closing date',
        accessor: 'closing_date',
        Cell: DateCell
    },
    {
        Header: 'Results date',
        accessor: 'results_date',
        Cell: DateCell
    },
    {
        Header: 'Awards date',
        accessor: 'awards_date',
        Cell: DateCell
    }
] as Column<Interfaces.Salon>[]